<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                    <el-form-item prop="deviceNo" label="设备编号">
                        <el-input v-model="form.deviceNo" maxlength="80" style="width:230px;"></el-input>
                    </el-form-item>
                    
                    <el-form-item   prop="deviceSysId" label="系统">
                       <el-select v-model="form.deviceSysId" clearable placeholder="请选择" style="width:230px;">
                            <el-option
                                v-for="item in deviceSys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item prop="passNo" label="通道编号">
                        <el-input v-model="form.passNo" maxlength="80" style="width:230px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="deviceType" label="设备类型">
                       <el-select v-model="form.deviceType" clearable placeholder="请选择" style="width:230px;">
                            <el-option
                                v-for="item in deviceTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
 
                    <el-form-item   prop="deviceModel" label="设备型号">
                        <el-input v-model="form.deviceModel" maxlength="100" style="width:230px;"></el-input>
                    </el-form-item> 
 
                    <el-form-item   prop="address" label="设备位置">
                        <el-input v-model="form.address" maxlength="100" style="width:230px;"></el-input>
                    </el-form-item> 

                    <el-form-item   prop="deviceAddress" label="设备地址">
                        <el-input v-model="form.deviceAddress" maxlength="300" placeholder="格式:摄像头登录账户:密码:IP:端口" style="width:230px;"></el-input>
                    </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    deptId:"",
                    deviceNo:"",
                    deviceSysId:"",
                    passNo:"",
                    deviceType:"",
                    deviceModel:"",
                    address:"",
                    deviceAddress:""
                },
                rules: {
                    deviceNo: [
                        { required: true, message: '请输入设备编号', trigger: 'blur' }
                    ],
                    // deviceSysId: [
                    //     { required: true, message: '请选择系统', trigger: 'blur' }
                    // ],
                    deviceType: [
                        { required: true, message: '请选择设备类型', trigger: 'blur' }
                    ],
                    address: [
                        { required: true, message: '请输入设备位置', trigger: 'blur' }
                    ]
                },
                deviceTypes:[{
                    value: 1,
                    label: '校园入口闸机'
                }, {
                    value: 2,
                    label: '人脸识别终端'
                }, {
                    value: 3,
                    label: '人脸考勤终端'
                }, {
                    value: 4,
                    label: '人脸识别摄像机'
                }, {
                    value: 5,
                    label: '无感考勤摄像机'
                }, {
                    value: 6,
                    label: '食堂人脸门禁'
                }, {
                    value: 7,
                    label: '行为识别摄像机'
                }, {
                    value: 8,
                    label: '录播摄像机'
                }, {
                    value: 9,
                    label: '访客人脸终端'
                }, {
                    value: 10,
                    label: '比特在线考勤'
                }],
                deviceSys:[]
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId=deptId;
                this.getDeviceSys();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            //设备系统
            getDeviceSys(){
                let url  = this.listDeviceSysSelectUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    // console.log("列表:"+JSON.stringify(res.data))
                    if(res.status==200){
                      this.deviceSys = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.deviceAddUrl;
                        let data = {
                            deptId:this.form.deptId,
                            deviceNo:this.form.deviceNo,
                            deviceSysId:this.form.deviceSysId,
                            passNo:this.form.passNo,
                            deviceType:this.form.deviceType,
                            deviceModel:this.form.deviceModel,
                            address:this.form.address,
                            deviceAddress:this.form.deviceAddress,
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/device/device/Add.vue